import axios from 'axios'

const getProvincias = async () => {
    try {
        return await axios({
            method: "get",
            url: `${process.env.REACT_APP_BACKEND_URL}/corralones/provincias`,
            responseType: 'json'
        });

    } catch (error) {
        console.log(error)
    }
}

export default getProvincias